import { create } from 'zustand';

const useModalStore = create((set) => ({
  zstIsOpen: false,
  zstModalName: null,
  zstProps: {},
  zstCloseCallback: null,
  zstOpenModal: ({ modalName, props, closeCallback }) =>
    set({ zstIsOpen: true, zstModalName: modalName, zstProps: props, zstCloseCallback: closeCallback }),
  zstCloseModal: () => set({ zstIsOpen: false, zstModalName: null, props: {}, zstCloseCallback: null }),
}));

export default useModalStore;
